import { Link } from 'react-router-dom';
import '../styles/Nav.scss';
import { navs } from '../utils/constants';

function Nav({ toggleMenu, isMenuOpen }) {
	return (
		<div className="Nav-container">
			<span className="Nav-logo">
				<Link to={'/'}>JULIANA</Link>
			</span>
			<div>
				<ul className="Nav-lists">
					{navs.map((nav, index) => (
						<li key={index}>
							<Link to={nav.path}>{nav.name}</Link>
						</li>
					))}
					<li>
						<a
							href="https://medium.com/@julieifionu"
							target="_blank"
							rel="noreferrer"
						>
							MY BLOG
						</a>
					</li>
				</ul>
				<div onClick={toggleMenu}>
					{!isMenuOpen && (
						<img
							src={'/images/icons/hamburger.svg'}
							className="Nav-hamburger"
							alt="Hamburger"
						/>
					)}
					{isMenuOpen && (
						<img
							src={'/images/icons/close.svg'}
							className="Nav-hamburger"
							alt="Hamburger"
						/>
					)}
				</div>
			</div>
		</div>
	);
}

export default Nav;
